import { lazy } from "react";
import Loadable from "../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../constants/enums";
import {
  AUTOMOBILE_POLICY_FORM_CANCELLATION_REINSTATEMENT,
  AUTOMOBILE_POLICY_FORM_CERTIFICATE_INSURANCE,
  AUTOMOBILE_POLICY_FORM_OPCF47R,
  AUTOMOBILE_POLICY_FORM_OPCF48,
  AUTOMOBILE_POLICY_FORM_OPCF49,
  AUTOMOBILE_POLICY_FORM_SEF13D,
  AUTOMOBILE_POLICY_FORM_SEF13H,
  AUTOMOBILE_POLICY_FORM_SEF16,
  AUTOMOBILE_POLICY_FORM_SEF17,
  AUTOMOBILE_POLICY_FORM_SEF19,
  AUTOMOBILE_POLICY_FORM_SEF28A,
  AUTOMOBILE_POLICY_FORM_SEF40,
} from "./Automobile.constants";

const AutomobileOPCF48 = Loadable(
  lazy(() =>
    import("./OPCF_48/OPCF_48").then(({ OPCF_48 }) => ({
      default: OPCF_48,
    }))
  )
);
const AutomobileOPCF47R = Loadable(
  lazy(() =>
    import("./AutomobilePolicyForms/AutomobileOPCF47R/AutomobileOPCF47R").then(({ AutomobileOPCF47R }) => ({
      default: AutomobileOPCF47R,
    }))
  )
);
const AutomobileOPCF49 = Loadable(
  lazy(() =>
    import("./OPCF_49/OPCF_49").then(({ OPCF_49 }) => ({
      default: OPCF_49,
    }))
  )
);
const AutomobileSEF16 = Loadable(
  lazy(() =>
    import("./SEF_16/SEF_16").then(({ SEF_16 }) => ({
      default: SEF_16,
    }))
  )
);
const AutomobileSEF17 = Loadable(
  lazy(() =>
    import("./SEF_17/SEF_17").then(({ SEF_17 }) => ({
      default: SEF_17,
    }))
  )
);
const AutomobileSEF19 = Loadable(
  lazy(() =>
    import("./SEF_19/SEF_19").then(({ SEF_19 }) => ({
      default: SEF_19,
    }))
  )
);
const AutomobileSEF13D = Loadable(
  lazy(() =>
    import("./SEF_13D/SEF_13D").then(({ SEF_13D }) => ({
      default: SEF_13D,
    }))
  )
);
const AutomobileSEF13H = Loadable(
  lazy(() =>
    import("./SEF_13H/SEF_13H").then(({ SEF_13H }) => ({
      default: SEF_13H,
    }))
  )
);
const AutomobileSEF40 = Loadable(
  lazy(() =>
    import("./SEF_40/SEF_40").then(({ SEF_40 }) => ({
      default: SEF_40,
    }))
  )
);
const AutomobileSEF28A = Loadable(
  lazy(() =>
    import("./SEF_28A/SEF_28A").then(({ SEF_28A }) => ({
      default: SEF_28A,
    }))
  )
);
const AutomobileCertificateInsurance = Loadable(
  lazy(() =>
    import(
      "./AutomobileCertificateInsurance/AutomobileCertificateInsurance"
    ).then(({ AutomobileCertificateInsurance }) => ({
      default: AutomobileCertificateInsurance,
    }))
  )
);
const AutomobileCancellation = Loadable(
  lazy(() =>
    import("./AutomobileCancellation/AutomobileCancellation").then(
      ({ AutomobileCancellation }) => ({
        default: AutomobileCancellation,
      })
    )
  )
);

const AutomobilePolicyIntactAuthorization = Loadable(
  lazy(() =>
    import("./AutomobilePolicyForms//AutomobilePolicyIntactAutorization/AutomobilePolicyIntactAuthorization").then(
      ({ AutomobilePolicyIntactAuthorization }) => ({
        default: AutomobilePolicyIntactAuthorization,
      })
    )
  )
);
const AutomobileLossNotice = Loadable(
  lazy(() =>
    import("./AutomobilePolicyForms/AutomobileLossNotice/AutomobileLossNotice").then(
      ({ AutomobileLossNotice }) => ({
        default: AutomobileLossNotice,
      })
    )
  )
);

export const AutomobilePolicyFormsRoutes = [
  {
    path: `${AUTOMOBILE_POLICY_FORM_OPCF48}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileOPCF48 />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_OPCF48}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileOPCF48 />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_OPCF48}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileOPCF48 isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_OPCF47R}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileOPCF47R />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_OPCF47R}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileOPCF47R />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_OPCF47R}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileOPCF47R isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_OPCF49}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileOPCF49 />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_OPCF49}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileOPCF49 />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_OPCF49}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileOPCF49 isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF16}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileSEF16 />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF16}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileSEF16 />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF16}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileSEF16 isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF17}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileSEF17 />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF17}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileSEF17 />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF17}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileSEF17 isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF19}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileSEF19 />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF19}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileSEF19 />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF19}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileSEF19 isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF13D}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileSEF13D />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF13D}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileSEF13D />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF13D}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileSEF13D isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF13H}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileSEF13H />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF13H}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileSEF13H />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF13H}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileSEF13H isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF40}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileSEF40 />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF40}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileSEF40 />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF40}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileSEF40 isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF28A}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileSEF28A />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF28A}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileSEF28A />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_SEF28A}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileSEF28A isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_CERTIFICATE_INSURANCE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileCertificateInsurance />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_CERTIFICATE_INSURANCE}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileCertificateInsurance />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_CERTIFICATE_INSURANCE}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileCertificateInsurance isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_CANCELLATION_REINSTATEMENT}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileCancellation />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_CANCELLATION_REINSTATEMENT}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileCancellation />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${AUTOMOBILE_POLICY_FORM_CANCELLATION_REINSTATEMENT}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileCancellation isDuplicate />
      </AuthorizedRoute>
    ),
  },
   {
    path: `/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/intact-authorization`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobilePolicyIntactAuthorization />
      </AuthorizedRoute>
    ),
  },
    {
    path: `/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/intact-authorization/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobilePolicyIntactAuthorization />
      </AuthorizedRoute>
    ),
  },
    {
    path: `/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/intact-authorization/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobilePolicyIntactAuthorization isDuplicate />
      </AuthorizedRoute>
    ),
  },
   {
    path: `/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/loss-notice`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileLossNotice />
      </AuthorizedRoute>
    ),
  },
    {
    path: `/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/loss-notice/:claimNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileLossNotice />
      </AuthorizedRoute>
    ),
  },
    {
    path: `/automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/loss-notice/duplicate/:claimNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileLossNotice isDuplicate />
      </AuthorizedRoute>
    ),
  },
];
